<template>
  <div id="app">
    <p id="support"></p>

    <p id=contentHolder></p>
    <video id="video"
           width="320"
           height="320"></video>
    <div class="photo">
      <p>拍照</p>
      <canvas id="canvas"
              style="display:none;background-color: #f00;"
              width="320"
              height="320"></canvas>
    </div>
    <br>
    <button id="snap"
            style="display:none;height:50px;width:120px">开始扫描</button>
    <div class="content">

    </div>
  </div>
</template>

<script>

import $ from 'jquery'
export default {
  name: "App",
  mounted () {
    this.init()
  },
  methods: {
    init () {
      var canvas = null, context = null, video = null;
      window.addEventListener('DOMContentLoaded', function () {
        //   console.log('sada')
        //   try {
        canvas = document.getElementById('canvas');
        context = canvas.getContext('2d');
        video = document.getElementById('video');
        betterWay()

        // var videoObj = {
        //   'video': true, audio: false
        // },
        //   flag = true,
        //   MediaErr = function (error) {
        //     console.log(error)
        //     flag = false;
        //     if (error.PERMISSION_DENIED) {
        //       alert('用户拒绝了浏览器请求媒体的权限', '提示');
        //     } else if (error.NOT_SUPPORTED_ERROR) {
        //       alert('对不起，您的浏览器不支持拍照功能，请使用其他浏览器', '提示');
        //     } else if (error.MANDATORY_UNSATISFIED_ERROR) {
        //       alert('指定的媒体类型未接收到媒体流', '提示');
        //     } else {
        //       alert('系统未能获取到摄像头，请确保摄像头已正确安装。或尝试刷新页面，重试', '提示');
        //     }
        //   };
        //获取媒体的兼容代码，目前只支持（Firefox,Chrome,Opera）
        console.log(navigator)
        // if (navigator.getUserMedia) {
        //   //qq浏览器不支持
        //   // if (navigator.userAgent.indexOf('MQQBrowser') === -1) {
        //   //   alert('对不起，您的浏览器不支持拍照功能，请使用其他浏览器', '提示');
        //   //   return false;
        //   // }
        //   navigator.getUserMedia(videoObj, function (stream) {
        //     console.log('stream', stream)
        //     try {
        //       video.srcObject = stream;
        //     } catch (error) {
        //       video.src = window.URL.createObjectURL(stream);
        //     }
        //     video.play();
        //   }, MediaErr);
        // }
        // else if (navigator.webkitGetUserMedia) {
        //   navigator.webkitGetUserMedia(videoObj, function (stream) {
        //     // video.src = window.webkitURL.createObjectURL(stream);
        //     try {
        //       video.srcObject = stream;
        //     } catch (error) {
        //       video.src = window.webkitURL.createObjectURL(stream);
        //     }
        //     video.play();
        //   }, MediaErr);
        // }
        // else if (navigator.mozGetUserMedia) {
        //   navigator.mozGetUserMedia(videoObj, function (stream) {
        //     try {
        //       video.srcObject = stream;
        //     } catch (error) {
        //       video.src = window.URL.createObjectURL(stream);
        //     }
        //     video.play();
        //   }, MediaErr);
        // }
        // else if (navigator.msGetUserMedia) {
        //   navigator.msGetUserMedia(videoObj, function (stream) {
        //     $(document).scrollTop($(window).height());
        //     try {
        //       video.srcObject = stream;
        //     } catch (error) {
        //       video.src = window.URL.createObjectURL(stream);
        //     }
        //     video.play();
        //   }, MediaErr);
        // } else {
        //   alert('对不起，您的浏览器不支持拍照功能，请使用其他浏览器');
        //   return false;
        // }
        // if (flag) {
        //   alert('为了获得更准确的测试结果，请尽量将二维码置于框中，然后进行拍摄、扫描。 请确保浏览器有权限使用摄像功能');
        // }
        // //这个是拍照按钮的事件，          
        // $('#snap').click(function () { startPat(); }).show();
        //   } catch (e) {
        //     printHtml('浏览器不支持HTML5 CANVAS');
        //   }
      }, false);

      // //打印内容到页面      
      // function printHtml(content) {
      //   $(window.document.body).append(content + '& lt; br /===');
      // }
      //开始拍照
      function startPat () {
        setTimeout(function () {//防止调用过快
          if (context) {
            context.drawImage(video, 0, 0, 320, 320);
            $('#canvas').show()
            var imgData = canvas.toDataURL();
            //将图像转换为base64数据
            var base64Data = imgData.substr(22);//.substr(22)
            // CatchCode();
            getToken(base64Data)
          }
        }, 200);
      }
      function getToken (img) {

        $.ajax({
          url: 'https://aip.baidubce.com/oauth/2.0/token',
          type: 'post',
          data: {
            grant_type: 'client_credentials',
            client_id: '4BGFpElWtDRxEGSFHk2IPhlO',
            client_secret: 'IVnDBhwomb9gHR4S6KXd3NxzkY9jIFlk'
          },
          crossDomain: true,
          dataType: 'json',
          header: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          async: true,
          success (res) {
            updateImg(img, res.access_token)
          }
        })
        updateImg(img)
      }
      // 上传图片
      function updateImg (img, token = '24.5482bb4d10f9cee994827038ebd18e2b.2592000.1611121199.282335-16029999') {
        $.ajax({
          url: 'https://aip.baidubce.com/rest/2.0/ocr/v1/idcard',
          type: 'POST',
          data: {
            image: img,
            id_card_side: 'front',
            access_token: token
          },
          crossDomain: true,
          dataType: 'json',
          header: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          async: true,
          success (res) {
            console.log(res)
            $('.content').html(res)
          }
        })
        // $.post('https://aip.baidubce.com/rest/2.0/ocr/v1/idcard?access_token=' + accessToken,)
      }
      function betterWay () {
        // 老的浏览器可能根本没有实现 mediaDevices，所以我们可以先设置一个空的对象
        // if (navigator.mediaDevices === undefined) {
        //   navigator.mediaDevices = {};
        // }
        // if (navigator.mediaDevices.getUserMedia === undefined) {
        //   navigator.mediaDevices.getUserMedia = function (constraints) {
        //     // 首先，如果有getUserMedia的话，就获得它
        //     var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

        //     // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
        //     if (!getUserMedia) {
        //       return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
        //     }

        //     // 否则，为老的navigator.getUserMedia方法包裹一个Promise
        //     return new Promise(function (resolve, reject) {
        //       getUserMedia.call(navigator, constraints, resolve, reject);
        //     });
        //   }
        // }
        console.log(navigator, navigator.mediaDevices)
        const constraints = {
          'video': true,
          audio: false
        };
        let promise = navigator.mediaDevices.getUserMedia(constraints);

        promise.then(stream => {
          let v = document.getElementById('video');
          // 旧的浏览器可能没有srcObject
          if ("srcObject" in v) {
            v.srcObject = stream;
          } else {
            // 防止再新的浏览器里使用它，应为它已经不再支持了
            v.src = window.URL.createObjectURL(stream);
          }

          v.onloadedmetadata = function () {
            v.play();
          };

          //这个是拍照按钮的事件，          
          $('#snap').click(function () { startPat(); }).show();
        }).catch(err => {
          console.error(err.name + ": " + err.message);
        })
      }
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#video {
  margin-right: 50px;
}
#canvas {
}
</style>
